import React from 'react'
import File from './File'
import Html from './Html'
import Button from './Button'
// { date: "2024-01-05", time: "16:03", status: "已审核", title: "审核通过", person: "王五" },

const Node = props => {
	const {
		log: { date, time, status, title, person, files, htmls, buttons },
		log,
		allLogs,
		buttonHandle, // 按钮点击处理函数，参数为 (button, log, allLogs)，button为按钮配置，log为当前日志，allLogs为所有日志
		prev, prev: { date: prevDate, status: prevStatus } = {}, first, last
	} = props

	return <div className='t-node'>
		<div className={`status-line${first ? ' first' : last ? ' last' : ''}`} />
		<div className='status-icon-wrap'>
			<div className={`status-icon${first ? ' first' : ''}${status == prevStatus ? '' : ' big'}`} />
		</div>
		<div className='date'>{date == prevDate ? '' : date}</div>
		<div className='time'>{time}</div>
		<div className='detail'>
			<div className='txt'>
				{status == prevStatus ? null : <div className='stress-txt'><b>{status}</b></div>}
				<span className='title'>{title}</span>{person ? <span className='person'>({person})</span> : null}
				{htmls?.length
					? htmls.map((html, index) => <Html key={index} html={html} />)
					: null
				}
				{buttons?.length && buttonHandle
					? buttons.map((button, index) => <Button key={index} {...{button, log, allLogs, buttonHandle}}/>)
					: null
				}
			</div>
			{files?.length
				? <div className='files'>
					{files.map((file, index) => <File key={index} file={file} />)}
				</div>
				: null
			}
		</div>
	</div>
}

export default Node